<template>
  <DefaultCheckbox
    id="newsletterSubscription"
    :modelValue="isSubscribedToNewsletter"
    @update:modelValue="onChange"
    :checked="isSubscribedToNewsletter"
  >
    {{ $t("newsletter.receiveNewsletter") }}
  </DefaultCheckbox>
</template>

<script setup>
const props = defineProps({
  isSubscribedToNewsletter: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["onChange"]);

const onChange = (value) => {
  emit("onChange", value);
};
</script>
